export default function getTitleToDisplay(t, title, privetEventsTitle, accessRole, isPrivate) {
    var titleToDisplay = title;
    // if (!isDetailsVisible) {
    //   titleToDisplay = t('Google_Calendar_Busy');
    // }
    if (accessRole === 'freeBusyReader') {
        titleToDisplay = t('Google_Calendar_Busy');
    }
    if (isPrivate && accessRole !== 'freeBusyReader') {
        titleToDisplay = t('Google_Calendar_Private');
        if (typeof privetEventsTitle !== 'undefined' &&
            privetEventsTitle.length > 0) {
            titleToDisplay = privetEventsTitle;
        }
    }
    return titleToDisplay;
}
//# sourceMappingURL=getTitleToDisplay.js.map